<template>
  <header>
    <h1>Drivmedelsguiden</h1>
    <div class="row article-row">
      <article>Här kan du enkelt jämföra aktuella drivmedelspriser mellan olika aktörer och se hur valet påverkar den totala drivmedelskostnaden per år – för en eller flera företagsbilar.</article>
    </div>
    <div class="row button-row" v-if="target">
      <div class="button" v-on:click="scrollDown">Jämför priser direkt</div>
    </div>
  </header>
</template>

<script>
  import scrollDown from 'lib/scrollDown'
  import sizzle from 'sizzle'

  export default {
    data () {
      return {
        target: null
      }
    },
    mounted () {
      this.target = sizzle('.calculator')[0]
    },
    methods: {
      scrollDown () {
        scrollDown(this.target.offsetTop)
      }
    }
  }
</script>

<style rel="stylesheet/scss" type="text/css" lang="scss" scoped>
  @import "~styles/sizes.scss";
  @import "~styles/button.scss";

  // TODO: Update with picture sizes according to viewport size
  header {
    width: 100%;
    min-height: 100%;
    background: url('~assets/images/bgHeader.jpg') no-repeat center bottom;
    background-size: cover;
    overflow: hidden;
    text-align: center;

    @media screen and (max-width: $large) {
      background: url('~assets/images/bgHeader.jpg') no-repeat center bottom;
      background-size: cover;
    }

    @media screen and (max-width: $medium) {
      height: 100%;
      min-height: 0;
      max-height: 400px;
      /*
      background: linear-gradient(
          rgba(0, 0, 0, 0.3),
          rgba(0, 0, 0, 0.3)
      ), url('~assets/images/bgHeader.jpg') no-repeat center bottom;
      */
      background-size: cover;
    }

    @media screen and (max-width: $small) {
      /*
      background: linear-gradient(
          rgba(0, 0, 0, 0.2),
          rgba(0, 0, 0, 0.2)
      ), url('~assets/images/bgHeader.jpg') no-repeat center bottom;
      background-size: cover;
      */
    }

    h1 {
      font-family: 'Volvo Sans Medium', sans-serif;
      font-weight: normal;
      color: #fff;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      font-size: 3em;
      text-align: center;
      margin-top: 2em;

      @media screen and (max-width: $large) {
        font-size: 2em;
      }

      @media screen and (max-width: $medium) {
        font-size: 1.5em;
      }
    }

    article {
      color: #fff;
      display: inline-block;
      max-width: 750px;
      font-size: 1.1em;
      line-height: 1.8em;
      padding: 0 15px;

      @media screen and (max-width: $large) {
        font-size: 1em;
      }

      @media screen and (max-width: $medium) {
        font-size: 0.9em;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// header.vue?30f4c596